import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses, mobileIs, componentId } from "../../utils/siteUtils";
import { BackgroundImage } from "../../elements";
import "./style.scss";
const IntroductionBlock = props => {
  const { lang, rendering, fields, page } = props;
  const { pc_image, m_image, title, list } = fields;
  const isMobile = mobileIs()
  const renderingClass = 'c-section-title' + '_' + rendering.dataSource;
  const titleNode = useRef();

  const rootClasses = classNames("c-introduction-block", renderingClass, getOverallSettingsClasses(fields));
  const rootId = componentId(rendering);
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} id={rootId}>
      {!isMobile && <BackgroundImage {...pc_image} className="c-introduction-block__image__pc" />}
      {isMobile && <BackgroundImage {...m_image} className="c-introduction-block__image__mobile" />}
      <div className="c-introduction-block__title__content" ref={titleNode}>
        <RichText className="c-introduction-block__title" tag="div" field={title} />
      </div>
      <div className="c-introduction-block__list__content">
        {list?.map((item, index) => (
          <React.Fragment key={index}>
            <div className="c-introduction-block__list__content__item">
              <RichText className="c-introduction-block__list__content__item__title" tag="div" field={item?.fields?.title} />
              <RichText className="c-introduction-block__list__content__item__description" tag="div" field={item?.fields?.description} />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default IntroductionBlock;